/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {completeCopyModal} from '../../common/util/complete-copy-modal';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import {nextCopyTitle} from '../../../components/util/next-copy-title';
import {Uuid} from '../../../components/util/uuid';
import {RoleApiService} from './role-api.service';
import {FormsModule} from '@angular/forms';
import {APP_SHARED} from '../../common/app-shared';

export interface RoleCopyResult {
  model: any;
  destination: boolean;
}

@Component({
  standalone: true,
  imports: [...APP_SHARED, FormsModule],
  selector: 'adn-role-copy-modal',
  template: `
    <form class="form-horizontal" (ngSubmit)="copy()">
      <div class="modal-header dialogAddStuff">
        <button type="button" class="close" (click)="dismiss()">&times;</button>
        <h4 class="modal-title">
          <span>{{ 'label.copy.role' | ogTranslate }}</span>
          <small>{{originalName}}</small>
        </h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="col-md-3 control-label">{{ 'label.name' | ogTranslate }}</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="role.name" [(ngModel)]="name" required>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">{{ 'label.description' | ogTranslate }}</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="role.description" [(ngModel)]="description">
          </div>
        </div>
        <p class="alert alert-info">The role's type, scope and permissions will be copied across to the new role.</p>
        <div class="checkbox text-right">
          <label class="checkbox">
            <input type="checkbox" [(ngModel)]="destination" name="role.destination">
            <span class="small">Go to new role after copy</span>
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <a class="btn btn-link btn-xs" (click)="dismiss()">{{ 'button.cancel' | ogTranslate }}</a>
        <button type="submit" class="btn btn-default">{{ 'label.copy' | ogTranslate }}</button>
      </div>
    </form>
  `
})
export class RoleCopyModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  model: any;

  readonly onCopied = new Subject<RoleCopyResult>();

  originalName = '';
  name = '';
  description = '';
  destination = true;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly roleApi: RoleApiService
  ) {}

  ngOnInit(): void {
    this.originalName = this.model?.name || '';
    this.name = nextCopyTitle(this.model?.name || '');
    this.description = this.model?.description || '';
  }

  copy(): void {
    const copy = _.cloneDeep({...this.model,
      id: Uuid.generate(),
      name: this.name,
      description: this.description
    });
    this.roleApi.save(copy).subscribe((saved) => {
      completeCopyModal(this.bsModalRef, this.onCopied, {model: saved, destination: this.destination});
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
